<template>
  <section class="mt-2">
    <v-dialog persistent v-model="formDialogVisible" max-width="400px">
      <v-card>
        <v-form ref="form" v-model="valid">
          <v-toolbar color="grey lighten-3 font-weight-bold " flat dense>
            <span class="subtitleFontsize">State Info</span>
            <v-spacer></v-spacer>
            <v-btn depressed small icon @click="closeFormDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-0">
            <v-row no-gutters>
              <v-col cols="12" md="12">
                <label class="my-0 rounded labelFontsize required"> State Name </label>
                <v-autocomplete
                  dense
                  outlined
                  v-model="postState.state_code"
                  placeholder="State Name"
                  :items="stateDetails"
                  class="rounded"
                  item-text="name"
                  item-value="state_code"
                  :rules="FieldRequired('State Name')"
                >
                </v-autocomplete>
                <label class="my-0 rounded labelFontsize required"> City Name </label>
                <v-text-field
                  dense
                  outlined
                  v-model="postState.name"
                  placeholder="City Name"
                  class="rounded"
                  :rules="FieldRequired('City Name')"
                >
                </v-text-field>

                <label class="my-0 rounded labelFontsize"> Latitude </label>
                <v-text-field
                  placeholder="Latitude"
                  dense
                  outlined
                  v-model="postState.latitude"
                  class="rounded"
                ></v-text-field>
                <label class="my-0 rounded labelFontsize"> Longitude </label>
                <v-text-field
                  placeholder="Longitude"
                  dense
                  outlined
                  v-model="postState.longitude"
                  class="rounded"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider class="pa-0 ma-0"></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              depressed
              small
              color="primary"
              class="text-capitalize"
              outlined
              @click="closeFormDialog"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon> Cancel
            </v-btn>
            <v-btn
              depressed
              color="primary"
              class="text-capitalize"
              small
              @click="onSubmitFor()"
            >
              {{ postState.id ? "Update" : "Add" }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
    <template>
      <v-row class="mt-5 ms-0">
        <v-col cols="12" lg="3" xs="12">
          <v-autocomplete
            dense
            outlined
            v-model="selectedCity"
            placeholder="State Name"
            :items="stateDetails"
            class="rounded"
            item-text="name"
            item-value="state_code"
          >
          </v-autocomplete>
        </v-col>
        <v-btn
          depressed
          class="text-capitalize ms-2"
          small
          color="primary"
          outlined
          @click="getAllCitiesInfoData()"
        >
          Get Cities
        </v-btn>
        <!-- <v-btn depressed 
            class="text-capitalize ms-6"
            small
            color="primary"
            outlined
            @click="getAllStateDetailsById"
          >
            Get States
          </v-btn> -->
        <v-btn
          depressed
          class="text-capitalize ms-3 me-3"
          small
          color="primary"
          @click="openFormDialog()"
        >
          <v-icon small class="me-2">mdi-content-save-plus-outline</v-icon> Add
        </v-btn>
        <v-btn depressed @click="downloadExcelsheet" color="primary" small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>

        <v-spacer></v-spacer>

        <v-col cols="12" lg="4" xs="12">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter the table data."
            single-line
            class="me-4 mx-2"
            dense
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </template>
    <v-data-table fixed-header  height="55vh"
      :headers="headers"
      dense
      :search="search"
      class="p-1"
      :items="cityDetails"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.is_active="{ item }">
        <v-switch
          v-model="item.is_active"
          height="0px"
          color="success"
          dense
          @change="isactiveupdate(item)"
        ></v-switch>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small color="primary" class="mr-2" @click="editItem(item)">
          mdi-content-save-edit-outline
        </v-icon>
        <v-icon small color="primary" @click="deleteItem(item)">
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>
    <!-- delete dialog -->
    <v-dialog persistent v-model="dialogDelete" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3">Are you sure you want to delete?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed small color="primary" outlined @click="deleteItemConfirm">
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed small color="primary" outlined @click="dialogDelete = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <loading :active="loader" :opacity="0.9" color="#ff6b00" />
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import setupService from "@/services/SetupService/setupService";
import { FieldRequired } from "@/utils/validation.js";

export default {
  name: "Addmastercat",
  mixins: [alerts],
  data() {
    return {
      FieldRequired,
      valid: true,
      search: "",
      editedIndex: -1,
      formDialogVisible: false,
      dialogDelete: false,
      validate: null,
      selectpamaterType: "new",
      selectedCity: "",
      stateDetails: [],
      cityDetails: [],
      postState: {
        name: "",
        country_code: "",
        state_code: "",
        latitude: "",
        longitude: "",
      },
      loader: false,
      headers: [
        {
          text: "State Name",
          value: "state_code",
        },
        { text: "City Name", value: "name" },
        { text: "Latitude", value: "latitude" },
        { text: "Longitude", value: "longitude" },

        { text: "Created By", value: "created_by", sortable: false },
        { text: "Action", value: "actions", sortable: false },
      ],
    };
  },
  props: {
    selectedItems: {
      type: Array,
    },
    prameterid: {
      type: String,
    },
  },
  components: {
    Loading,
  },

  computed: {},
  mounted() {
    this.getAllStateInfoData();
  },
  methods: {
    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },
    async downloadExcelsheet() {
      if (this.cityDetails) {
        this.exportToExcel(this.headers, this.cityDetails, "cities_list");
      }
    },
    openFormDialog() {
      this.formDialogVisible = true;
      if (this.validate == true) {
        this.$refs.form.resetValidation();
      }
      this.postState = {};
    },
    closeFormDialog() {
      this.formDialogVisible = false;
      this.validate = true;
      this.$refs.form.resetValidation();
    },
    async getAllCitiesInfoData() {
      this.loader = true;
      try {
        const response = await setupService.getCitiesList(
          this.$route.query.iso3,
          this.selectedCity
        );
        if (response.data.status_code === 200) {
          if (!response.data.data[0]) {
            this.showAlertError("No Cities are added");
          } else {
            this.cityDetails = response.data.data.reverse();
          }
          console.log("states", this.cityDetails);
          this.stoploader();
        } else {
          this.showAlertError("Failed:" + response.data.message);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
        this.cityDetails = [];
      }
    },
    async getAllStateInfoData() {
      try {
        const response = await setupService.getStatesByCountry(this.$route.query.iso3);
        if (response.data.status_code === 200) {
          this.stateDetails = response.data.data;
          this.selectedCity = this.stateDetails[0].state_code;
          console.log("states", this.stateDetails);
        } else {
          this.showAlertError("Failed:" + response.data.message);
        }
      } catch (e) {
        console.error(e);
        this.stateDetails = [];
      }
    },
    editItem(item) {
      this.formDialogVisible = true;
      this.editedIndex = this.cityDetails.indexOf(item);
      this.postState = Object.assign({}, item);
    },
    onSubmitFor() {
      if (this.postState.id) {
        console.log("details");
        this.update();
      } else {
        console.log("else");
        this.save();
      }
      this.validate = true;
    },
    async save() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        this.postState.country_code = this.$route.query.iso3;
        try {
          const responseData = await setupService.addCityInfoData(this.postState);
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess("Updated: " + responseData.data.message);
            this.getAllCitiesInfoData();
            this.formDialogVisible = false;
            this.stoploader();
          } else {
            this.showAlertError("Failed:" + responseData.data.message);
            this.loader = false;
          }
        } catch (e) {
          console.error(e);
          this.loader = false;
        }
      }
    },
    async update() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loader = true;
        try {
          const responseData = await setupService.updateCityInfoData(
            this.postState.id,
            this.postState
          );
          if (responseData && responseData.data.status_code == 200) {
            this.showAlertSuccess("Updated: " + responseData.data.message);
            this.getAllCitiesInfoData();
            this.formDialogVisible = false;
            this.stoploader();
          } else {
            this.showAlertError("Failed:" + responseData.data.message);
            this.loader = false;
          }
        } catch (e) {
          console.error(e);
          this.loader = false;
        }
      }
    },
    deleteItem(item) {
      this.dialogDelete = true;
      this.deleted_id = item.id;
      console.log(item);
    },
    async deleteItemConfirm() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteCityInfoData(this.deleted_id);
        if (responseData && responseData.data.status_code == 200) {
          this.showAlertSuccess(responseData.data.message);
          this.getAllCitiesInfoData();
          this.stoploader();
          this.dialogDelete = false;
        } else {
          this.showAlertError(responseData.data.message);
          this.loader = false;
        }
      } catch (e) {
        console.error(e);
        this.loader = false;
      }
    },
  },
};
</script>

<style>
.required:after {
  content: " *";
  color: red;
}
</style>
